import "./../styles.scss";

import { notification } from "antd";
import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";

import CloseModal from "../../../components/icons/CloseModal";
import { SocketContext } from "../../../context/socket";

const YouTubeCsvTable = ({ ...props }) => {
  const { getYoutubeDownloadVideosData, setLoder } = props;
  const { webhookSocket } = useContext(SocketContext);
  const { entityId } = useOutletContext();

  const [model, setModel] = useState(false);

  const [socketUpdate, setSocketUpdate] = useState({});
  const [arrCSVFileData, setArrCSVFileData] = useState([]);
  const [arrYoutubeDownloadData, setArrYoutubeDownloadData] = useState([]);
  const handleClose = () => {
    setModel(false);
  };
  const handleOpenModel = (index) => {
    const file = arrCSVFileData[index]?.fileData;
    if (file) {
      setArrYoutubeDownloadData(file);
      setModel(true);
    }
  };

  const getYoutubeDownloadData = async () => {
    try {
      setLoder(true);
      let objRequestBody = new FormData();
      objRequestBody.append("entityId", entityId);
      const youtubeDownloadData = await getYoutubeDownloadVideosData(objRequestBody);
      if (youtubeDownloadData.value.status) {
        setArrCSVFileData(youtubeDownloadData.value.data);
        setLoder(false);
      } else {
        setLoder(false);
        notification["error"]({ message: youtubeDownloadData.value.message });
      }
    } catch (error) {
      setLoder(false);
      notification["error"]({ message: error.message });
    }
  };

  useEffect(() => {
    getYoutubeDownloadData();
    webhookSocket.on(`youtubeVideosDownload${entityId}`, (data) => {
      //call socket use effect here
      setSocketUpdate({
        entityId: data?.entityId,
        uniqueId: data?.uniqueId,
        status: data?.status || false,
      });
    });
  }, []);

  const handleDownloadUrl = async (data) => {
    const { event, url } = data;
    setLoder(true);
    try {
      if (url !== "") {
        let response = await fetch(url, { method: "HEAD" });
        if (response.ok) {
          window.open(url, "_blank");
        } else {
          notification["error"]({ message: "Your video is not ready yet, please check after sometime." });
        }
      } else {
        notification["error"]({ message: "Your video is not available. Please upload it again." });
      }
      setLoder(false);
    } catch (error) {
      setLoder(false);
      notification["error"]({ message: error.message });
    }
  };

  useEffect(() => {
    if (socketUpdate.status) {
      getYoutubeDownloadData();
      notification["success"]({ message: "New file uploaded Successfully" });
    }
  }, [socketUpdate]);

  return (
    <div className="border-block mt-3">
      <div className="row">
        <div className="col-md-12">
          <div className="table-resposive table-container user-management-table">
            <table className="table">
              <>
                <thead>
                  <tr>
                    <th className="table-action-block text-center">File Name</th>
                    <th className="table-action-block text-center">Uploaded Date</th>
                    <th className="table-action-block text-center" style={{ textAlign: "center" }}>
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {arrCSVFileData?.length > 0 ? (
                    arrCSVFileData?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className="table-action-block text-center cursor-pointer">
                            {item.csvLink === "" ? (
                              <>{item.fileName}</>
                            ) : (
                              <a href={item.csvLink} target="_blank" rel="noreferrer">
                                {item.fileName}
                              </a>
                            )}
                          </td>
                          <td className="table-action-block text-center">{item.createdAt.split("T")[0]}</td>
                          <td className="table-action-block text-center">
                            <button
                              className="btn btn-primary small-btn small-padding mt-3 mt-md-0"
                              onClick={() => handleOpenModel(index)}
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </tbody>
              </>
              <tfoot></tfoot>
            </table>
          </div>
        </div>
      </div>
      <Modal
        isOpen={model}
        // onAfterOpen={afterOpenModal}
        onRequestClose={handleClose}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-lg modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Info</h5>
            <button type="button" onClick={handleClose} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <div>
            <div className="table-resposive table-container user-management-table">
              <table className="table">
                <thead>
                  <tr>
                    <th className="table-action-block text-center">Show Name</th>
                    <th className="table-action-block text-center">Ep No</th>
                    <th className="table-action-block text-center">YT Link</th>
                    <th className="table-action-block text-center">URL</th>
                    <th className="table-action-block text-center">Status</th>
                    <th className="table-action-block text-center">Message</th>
                  </tr>
                </thead>
                <tbody>
                  {arrYoutubeDownloadData?.length > 0 ? (
                    arrYoutubeDownloadData?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className="table-action-block text-center p-2">
                            {item.ShowName === "" ? "-" : item.ShowName}
                          </td>
                          <td className="table-action-block text-center p-2">{item.EpNo === "" ? "-" : item.EpNo}</td>
                          <td className="table-action-block text-center p-2">
                            {item.YTLink === "" ? (
                              "-"
                            ) : (
                              <a href={item.YTLink} target="_blank" rel="noreferrer">
                                YouTube
                              </a>
                            )}
                          </td>
                          <td className="table-action-block text-center p-2">
                            {!item.URL || item.URL === "" ? (
                              "-"
                            ) : (
                              <div
                                className="cursor-pointer"
                                onClick={(event) => handleDownloadUrl({ event, url: item.URL })}
                              >
                                Download URL
                              </div>
                            )}
                          </td>
                          <td className="table-action-block text-center p-2">
                            {item.Status ? item.Status.toString() : "-"}
                          </td>
                          <td className="table-action-block text-center p-2">
                            {item.Message && item.Message !== "" ? item.Message.toString() : "-"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <h1>No YouTube data</h1>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default YouTubeCsvTable;
